<template>
    <div>
        <v-app class="d-flex flex-column">
            <Header v-show="!isLayoutHidden" />
            <NoticeBar v-show="!isLayoutHidden" />

            <v-main :class="['daon-main-wrap', { 'daon-main-wrap--no-header': isLayoutHidden }]">
                <router-view :key="['ShopDetails', 'ShopCoupons', 'ShopProducts'].includes($route.name) ? null : $route.path"></router-view>
            </v-main>

            <Footer v-show="!isFooterHidden" :class="[{ 'd-none': routerLoading }]" />

            <BottomChat v-if="false" />
            <SidebarCart />
            <AddToCartDialog />
            <LoginDialog v-if="!isAuthenticated" />
            <SnackBar />
        </v-app>
    </div>
</template>

<script>
    import Header from './header/Header.vue';
    import Footer from './footer/Footer.vue';
    import SidebarCart from './sidebar/Sidebar.vue';
    import BottomChat from './inc/BottomChat.vue';
    import SnackBar from './inc/SnackBar.vue';
    import LoginDialog from './auth/LoginDialog.vue';
    import AddToCartDialog from './product/AddToCartDialog.vue';
    import NoticeBar from './inc/NoticeBar.vue';
    import { mapGetters, mapActions, mapMutations } from 'vuex';
    export default {
        metaInfo() {
            return {
                title: this.currentUserShopMetaTitle || this.appMetaTitle,
            };
        },
        components: {
            Header,
            Footer,
            BottomChat,
            SidebarCart,
            SnackBar,
            LoginDialog,
            AddToCartDialog,
            NoticeBar,
        },
        computed: {
            ...mapGetters('auth', ['isAuthenticated', 'currentUserShopMetaTitle', 'shopTheme', 'shopUseFooter']),
            ...mapGetters('app', ['appMetaTitle', 'userLanguageObj', 'routerLoading']),
            isLayoutHidden() {
                return this.$route.meta?.hideShopLayout || ['Login'].includes(this.$route.name);
            },
            isFooterHidden() {
                return this.isLayoutHidden || !this.shopUseFooter;
            },
            is_mobile() {
                const isMobile = window.matchMedia('only screen and (max-width: 760px)');
                return isMobile.matches ? true : false;
            },
        },
        methods: {
            ...mapActions('auth', ['getUser', 'checkSocialLoginStatus']),
            ...mapMutations('auth', ['setSociaLoginStatus']),
            ...mapMutations('app', ['setIsMobile']),
        },
        async created() {
            this.$vuetify.rtl = false;

            await this.getUser();

            setTimeout(() => {
                this.checkSocialLoginStatus();
            }, 200);

            this.setIsMobile(this.is_mobile);
        },
    };
</script>
<style lang="scss" scoped>
    .absolute-full {
        background: #fff;
        z-index: 10000;
    }
</style>
